import React from "react";
import {Tooltip} from "antd";
import styles from "./index.module.scss";

const CustomTooltip = ({description, shortcut = null, placement = "top", children}) => {
  return (
    <Tooltip
      overlayInnerStyle={{
        display: "flex",
        alignItems: "center",
        background: "#131417",
        borderRadius: "2px",
        padding: "2px 6px",
      }}
      title={
        <>
          <div className={styles.description}>{description}</div>
          {shortcut && <div className={styles.shortcut}>{shortcut}</div>}
        </>
      }
      placement={placement}
    >
      {children}
    </Tooltip>
  );
};

export default React.memo(CustomTooltip);
